import { useMutation, useQueryClient } from '@tanstack/react-query';

import { DrugsApi } from '@/api/domains/drugs.api';
import { DrugsQueryKeys } from '@/api/domains/drugs.query-keys';
import {
  ConfirmationDeleteDialog,
  ConfirmationDialogBodyCard,
  ConfirmationDialogBodyMutedText,
  ConfirmationDialogBodyText,
  useGlobalErrorStore,
} from '@/components/dialogs';
import {
  selectNomenclatureStoreSelectedRow,
  useNomenclatureStore,
  useNomenclatureStoreActions,
  useNomenclatureStoreContextWindowsState,
} from '@/components/nomenclature/useNomenclatureStore';

// ----------------------------------------------------------------------

export const NomenclatureDeleteDialog = () => {
  const { closeDeleteDialog, closeEditModal } = useNomenclatureStoreActions();
  const { isDeleteDialogVisible, isEditModalVisible } = useNomenclatureStoreContextWindowsState();
  const drug = useNomenclatureStore(selectNomenclatureStoreSelectedRow);

  // ----------------------------------------------------------------------

  const { setGlobalError } = useGlobalErrorStore();

  const queryClient = useQueryClient();
  const { isLoading, mutate: deleteDrug } = useMutation({
    mutationFn: async () => {
      if (drug) {
        return DrugsApi.deleteDrugs({ ids: [drug.id] });
      }
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries(DrugsQueryKeys.root);

      closeDeleteDialog();

      if (isEditModalVisible) {
        closeEditModal();
      }
    },
    onError: setGlobalError,
  });

  const handleProceed = () => deleteDrug();

  return (
    <ConfirmationDeleteDialog
      open={isDeleteDialogVisible}
      isLoading={isLoading}
      onProceed={handleProceed}
      onClose={closeDeleteDialog}
    >
      {drug && (
        <ConfirmationDialogBodyCard>
          <ConfirmationDialogBodyText>{drug.name}</ConfirmationDialogBodyText>

          {drug.maker?.name && (
            <ConfirmationDialogBodyMutedText>
              {drug.maker.name} ({drug.maker.country})
            </ConfirmationDialogBodyMutedText>
          )}
        </ConfirmationDialogBodyCard>
      )}
    </ConfirmationDeleteDialog>
  );
};
